import React from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';
import Spinner from '../ui/Spinner';

const SmartSuggestModal = ({ onClose, suggestions, onShowDetail }) => {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.82)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(24px) saturate(180%)', WebkitBackdropFilter: 'blur(24px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: THEME.bgCard, borderRadius: '16px', padding: '24px', width: '90%', maxWidth: '700px', maxHeight: '85vh', overflow: 'auto', border: `1px solid ${THEME.border}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <div>
            <h2 style={{ margin: 0, color: THEME.text, fontSize: '22px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '28px' }}>🎯</span> What Should We Play?
            </h2>
            <p style={{ margin: '6px 0 0', color: THEME.textMuted, fontSize: '13px' }}>Smart recommendations based on your preferences</p>
          </div>
          <button onClick={onClose} style={{ background: 'transparent', border: 'none', color: THEME.textMuted, fontSize: '24px', cursor: 'pointer', padding: '8px' }}>×</button>
        </div>

        {suggestions.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: THEME.textMuted }}>
            <Spinner size={32} />
            <p style={{ marginTop: '16px' }}>Finding perfect games for you...</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {suggestions.map((game, idx) => (
              <div key={game.game_id} onClick={() => onShowDetail && api.get(`/api/games/${game.game_id}`).then(onShowDetail).catch(console.error)} style={{
                background: idx === 0 ? `linear-gradient(135deg, ${THEME.omega}15, ${THEME.supe}15)` : THEME.bg,
                border: `1px solid ${idx === 0 ? `${THEME.omega}40` : THEME.border}`,
                borderRadius: '12px',
                padding: '16px',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}>
                <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }}>
                  <img src={game.header_image} alt="" style={{ width: '120px', height: '56px', objectFit: 'cover', borderRadius: '8px' }} />
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '12px' }}>
                      <h3 style={{ margin: 0, color: THEME.text, fontSize: '16px', fontWeight: '600' }}>{game.game_name}</h3>
                      <div style={{
                        background: game.compatibility_score >= 70 ? THEME.success : game.compatibility_score >= 40 ? THEME.warning : THEME.textMuted,
                        color: '#000',
                        padding: '4px 10px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        fontWeight: '700',
                        flexShrink: 0
                      }}>
                        {game.compatibility_score}%
                      </div>
                    </div>

                    {/* Reasons */}
                    {game.reasons.length > 0 && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
                        {game.reasons.map((reason, i) => (
                          <span key={i} style={{ background: THEME.bgElevated, color: THEME.textSecondary, padding: '3px 8px', borderRadius: '6px', fontSize: '11px' }}>
                            {reason}
                          </span>
                        ))}
                      </div>
                    )}

                    {/* Stats row - dynamic users */}
                    <div style={{ display: 'flex', gap: '16px', marginTop: '10px', fontSize: '12px', color: THEME.textMuted }}>
                      {game.user_data ? Object.entries(game.user_data).map(([username, userData]) => (
                        <React.Fragment key={username}>
                          {userData.rating && <span style={{ color: userData.color || THEME.success }}>{userData.icon || ''} {userData.rating}/10</span>}
                        </React.Fragment>
                      )) : (
                        <>
                          {game.omega_rating && <span style={{ color: THEME.omega }}>Ω {game.omega_rating}/10</span>}
                          {game.supe_rating && <span style={{ color: THEME.supe }}>👑 {game.supe_rating}/10</span>}
                        </>
                      )}
                      <span>
                        {game.user_data ? Object.entries(game.user_data).map(([u, d], i) => `${i > 0 ? ' | ' : ''}${d.icon || ''} ${d.playtime_hours || Math.round((d.playtime || 0) / 60)}h`).join('')
                          : `Ω ${game.omega_hours}h | 👑 ${game.supe_hours}h`}
                      </span>
                    </div>

                    {/* Compatibility breakdown on hover/click */}
                    {game.compatibility_breakdown.length > 0 && (
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '8px' }}>
                        {game.compatibility_breakdown.slice(0, 4).map((item, i) => (
                          <span key={i} style={{ background: `${THEME.success}20`, color: THEME.success, padding: '2px 6px', borderRadius: '4px', fontSize: '10px' }}>
                            +{item.points} {item.label}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <p style={{ margin: '20px 0 0', color: THEME.textDim, fontSize: '11px', textAlign: 'center' }}>
          Press <kbd style={{ background: THEME.bgElevated, padding: '2px 6px', borderRadius: '4px', fontFamily: 'monospace' }}>W</kbd> to open this anytime
        </p>
      </div>
    </div>
  );
};

export default SmartSuggestModal;
